import { CommonModule } from '@angular/common';
import { Component, ViewChild, Optional } from '@angular/core';
import { SharedModule } from 'primeng/api';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { OverlayPanel, OverlayPanelModule } from 'primeng/overlaypanel';

@Component({
  standalone: true,
  imports: [CommonModule, SharedModule, OverlayPanelModule],
  selector: 'app-menu',
  templateUrl: './menu.component.html',
  styleUrls: ['./menu.component.scss'],
})
export class MenuComponent {
  @ViewChild('menuOverlay') menuOverlay!: OverlayPanel;

  constructor(
    @Optional() private readonly config?: DynamicDialogConfig,
    @Optional() public readonly dialogRef?: DynamicDialogRef
  ) { }

  menuItems: Array<{ title: string; url?: string }> = [
    { title: 'Home', url: 'https://qudos.us/' },
    { title: 'About Us', url: 'https://qudos.us/about/' },
    { title: 'Terms', url: 'https://qudos.us/terms/' },
    { title: 'Privacy', url: 'https://qudos.us/privacy/' },
  ];


  openMenu(event: Event) {
    this.menuOverlay.toggle(event);
  }

  onNavigate(item: any) {
    window.location.href = item?.url;
    this.menuOverlay.hide();
  }

  closeDialog() {
    if (this.dialogRef) {
      // this.dialogRef.close();
    }
  }
}
